import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { categoriesAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: any | null;
  onSuccess: () => void;
}

export function CategoriaProdutoDeleteDialog({ open, onOpenChange, item, onSuccess }: Props) {
  const handleConfirm = async () => {
    if (!item) return;
    try {
      await categoriesAdapter.delete(item.id_categoria);
      toast({ title: "Sucesso", description: "Categoria excluída com sucesso!" });
      onSuccess();
      onOpenChange(false);
    } catch (error: any) {
      console.error("Erro ao excluir categoria:", error);
      toast({ 
        title: "Erro", 
        description: error.message || "Não foi possível excluir.",
        variant: "destructive" 
      });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir Categoria</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir permanentemente a categoria "{item?.nome}"?
            Esta ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
